export default __webpack_public_path__ + "static/media/radio-select-vs-radio-avoid.81897f50.svg";